import dagre from 'dagre';
import { Position, type Edge } from '@xyflow/react';
import { NODE_WIDTH, NODE_HEIGHT, type OrgFlowNode } from './types';

/**
 * Runs a top-down dagre layout over the given nodes/edges and returns a new node
 * array with absolute positions. Pure function — safe to memoize and safe under
 * React StrictMode double-invocation.
 */
export function layoutWithDagre(nodes: OrgFlowNode[], edges: Edge[]): OrgFlowNode[] {
  const g = new dagre.graphlib.Graph();
  g.setDefaultEdgeLabel(() => ({}));
  g.setGraph({ rankdir: 'TB', nodesep: 40, ranksep: 70, marginx: 20, marginy: 20 });

  for (const node of nodes) {
    g.setNode(node.id, { width: NODE_WIDTH, height: NODE_HEIGHT });
  }
  for (const edge of edges) {
    g.setEdge(edge.source, edge.target);
  }

  dagre.layout(g);

  return nodes.map((node) => {
    const pos = g.node(node.id);
    return {
      ...node,
      // dagre reports node centers; React Flow positions by top-left corner.
      position: { x: pos.x - NODE_WIDTH / 2, y: pos.y - NODE_HEIGHT / 2 },
      targetPosition: Position.Top,
      sourcePosition: Position.Bottom,
    };
  });
}
